<img [src]="data.src" [alt]="data.alt">

<button mat-mini-fab color="accent" class="close-button" (click)="close()">
    <mat-icon svgIcon="close"></mat-icon>
</button>